import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./client";

/**
 * The retry policy IS the availability policy: retry only what a retry can
 * fix — no answer (NETWORK) or a dependency that did not answer (503).
 */
function shouldRetry(failureCount: number, error: unknown): boolean {
	if (!(error instanceof ApiError)) return false;
	return error.transient && failureCount < 3;
}

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: shouldRetry,
			retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
			staleTime: 30_000,
			// design.md rule 8: no refetch-on-focus storms. Live meets poll on their own clock.
			refetchOnWindowFocus: false,
		},
		mutations: {
			// A write is not idempotent; the row-save engine decides when to resend.
			retry: false,
		},
	},
});
